import React,{useEffect} from "react";
import { useParams } from "react-router";



import DemoSchedule from "../../components/BookDemo/thankyouPageGoogle/DemoSchedule";
import SuccessMessage from "../../components/BookDemo/thankyouPageGoogle/SuccessMessage";
import { initGA, initGtm } from "../../helpers/CampaignEvents";

const ThankYouPageGoogle = () => {
  const { component } = useParams();

  useEffect(() => {
    initGA()
  }, [])
  return (
    <div className="bookdemo-root ">
      <div className="container">
        <div className="bookdemo">

          {component === "success" ? (
             <SuccessMessage />
          ) :(
            <DemoSchedule />

          )}
        </div>
      </div>
    </div>
  );
};

export default ThankYouPageGoogle;
